import { render } from "./TempPopup.vue?vue&type=template&id=1000f181"
import script from "./TempPopup.vue?vue&type=script&lang=js"
export * from "./TempPopup.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__